module.exports = __webpack_public_path__ + "static/media/raikyuji.68858dbb.JPG";